var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState, useEffect } from 'react';
import logger from '../../../config/app.logger';
import { getExtendedLogger } from '../../Logger';
import { LOGGER_NAME } from '../config/constants';
import { getHighResolutionTime } from '../../../utils';
//@ts-ignore
import { noop } from '@mindtickle/utils';
var log = getExtendedLogger(LOGGER_NAME, logger);
var useDynamicScript = function (_a) {
    var url = _a.url, _b = _a.alreadyInitialised, alreadyInitialised = _b === void 0 ? false : _b, _c = _a.onLoad, onLoad = _c === void 0 ? noop : _c;
    var _d = __read(useState(alreadyInitialised), 2), ready = _d[0], setReady = _d[1];
    var _e = __read(useState(false), 2), failed = _e[0], setFailed = _e[1];
    useEffect(function () {
        if (!url || alreadyInitialised) {
            return;
        }
        var element = document.createElement('script');
        element.src = url;
        element.type = 'text/javascript';
        element.async = true;
        setReady(false);
        setFailed(false);
        var startLoadTime = getHighResolutionTime();
        element.onload = function () {
            onLoad(getHighResolutionTime() - startLoadTime);
            log("Dynamic Script Loaded: " + url);
            setReady(true);
        };
        element.onerror = function () {
            log("Dynamic Script Error: " + url);
            setReady(false);
            setFailed(true);
        };
        document.head.appendChild(element);
        return function () {
            log("Dynamic Script Removed: " + url);
            document.head.removeChild(element);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        ready: ready,
        failed: failed,
    };
};
export default useDynamicScript;
//# sourceMappingURL=useDynamicScript.js.map